import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GifOutlinedSvg from "@ant-design/icons-svg/es/asn/GifOutlined";
import AntdIcon from '../components/AntdIcon';
var GifOutlined = function GifOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: GifOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(GifOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'GifOutlined';
}
export default RefIcon;